import httpRequest from "../../../../network/httpRequest";
import { axiosUtils } from "../../../../network/axiosUtils";
import { HttpResponse } from "../../../../network/types";

const SIGN_OUT_URL = "/repair-shop/signout";
export const sendSignOut = async () => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: SIGN_OUT_URL,
  });
  return response;
};
export const LoginExtention = async () => {};
